import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DSModal from '../designSystem/DSModal';
import { PATHS } from '../../routes/paths';

interface ProfileIncompleteModalProps {
  isOpen: boolean;
  onClose?: () => void;
  dismissible?: boolean;
}

const ProfileIncompleteModal: React.FC<ProfileIncompleteModalProps> = ({
  isOpen,
  onClose,
  dismissible = false,
}) => {
  const { t } = useTranslation('translation');
  const navigate = useNavigate();

  const handleConfirm = () => {
    onClose?.();
    navigate(PATHS.MY_ACCOUNT);
  };

  return (
    <DSModal
      open={isOpen}
      size="compact"
      title={t('common.profileIncompleteModal.title')}
      description={t('common.profileIncompleteModal.description')}
      onClose={dismissible ? onClose : undefined}
      actions={[
        { label: t('common.profileIncompleteModal.action'), variant: 'primary', onClick: handleConfirm },
      ]}
    />
  );
};

export default ProfileIncompleteModal;
